import React from 'react';
import { BuyCreditsModal as SharedBuyCreditsModal, createCreditCheckoutViaSupabase } from '@rehub/buy-credits';
import { supabase } from '../services/supabase';
import type { UserProfile } from '../types';

interface BuyCreditsModalProps {
  user: UserProfile;
  onClose: () => void;
}

const BuyCreditsModal: React.FC<BuyCreditsModalProps> = ({ user, onClose }) => (
  <SharedBuyCreditsModal
    userId={user.id}
    credits={user.credits ?? 0}
    onClose={onClose}
    appSource="sketchplan"
    accent="orange"
    createCheckout={(params) => createCreditCheckoutViaSupabase(supabase, params)}
  />
);

export default BuyCreditsModal;
